<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <TopBar backPage="splash"/>

                <v-divider class=""></v-divider>

                <!-- Tabs -->
                <v-tabs v-model="tab" background-color="surface" grow class="my-4">
                    <v-tab v-if="$t('booking.tabs.services') != ' '" value="services">{{ $t('booking.tabs.services') }}</v-tab>
                    <v-tab v-if="$t('booking.tabs.employees') != ' '" value="employees">{{ $t('booking.tabs.employees') }}</v-tab>
                    <v-tab v-if="$t('booking.tabs.faqs') != ' ' && !!$store.state.info.faqs && $store.state.info.faqs != null && $store.state.info.faqs.length > 0" value="faqs">{{ $t('booking.tabs.faqs') }}</v-tab>
                    <v-tab v-if="$t('booking.tabs.about') != ' ' && !!$store.state.info.metas && $store.state.info.metas != null && $store.state.info.metas.length > 0" value="about">{{ $t('booking.tabs.about') }}</v-tab>
                </v-tabs>

                <v-tabs-window v-model="tab">
                    <v-tabs-window-item value="services">
                        <v-row class="pa-2"
                            v-if="!!$store.state.info.serives_cats && $store.state.info.serives_cats.length > 0">
                            <v-chip-group v-model="selectedCategory" active-class="primary--text" column>
                                <v-chip color="purple" variant="elevated" filter size="small" value="all">
                                    {{ $t('booking.all_categories') }}
                                </v-chip>
                                <v-chip color="purple" variant="elevated" 
                                      v-for="(cat, index) in $store.state.info.serives_cats.filter(c => c.count > 0)"
                                      :key="index" filter size="small" :value="cat.id">
                                    {{ cat.title }}
                                </v-chip>
                            </v-chip-group>
                        </v-row>
                        <v-row class="mt-4" v-if="!!$store.state.info.serives && $store.state.info.serives.length > 0">
                            <v-col cols="12" md="6"
                                v-for="(service, index) in $store.state.info.serives.filter(s => s.cat == selectedCategory || selectedCategory == 'all' || selectedCategory == null)"
                                :key="index">
                                <v-card class="pa-2" color="surface" elevation="3" rounded="lg">
                                    <div class="d-flex flex-column text-center">
                                        <v-img :src="$store.state.fileBaseUrl+service.image" height="200" cover></v-img>
                                        <h4>{{ service.title }}</h4>
                                        <v-btn
                                            @click="Booking_select_service(service)"
                                             elevation="5" color="primary" rounded="lg" class="mt-4">
                                            {{ $t('booking.reserve_button') }}
                                        </v-btn>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="faqs">
                        <Faqs v-if="!!$store.state.info.faqs && $store.state.info.faqs != null && $store.state.info.faqs.length > 0"/>
                    </v-tabs-window-item>
                    <v-tabs-window-item value="about">
                        <BusinessCardList v-if="!!$store.state.info.metas && $store.state.info.metas != null && $store.state.info.metas.length > 0"/>
                    </v-tabs-window-item>

                    <v-tabs-window-item value="comments">
                        <p>{{ $t('booking.comments_section') }}</p>
                    </v-tabs-window-item>
                    
                    <v-tabs-window-item value="employees">
                        <v-row class="mt-4"
                            v-if="!!$store.state.info.employees && $store.state.info.employees.length > 0">
                            <v-col cols="12" md="6" v-for="(employe, index) in $store.state.info.employees"
                                :key="index">
                                <v-card class="pa-2" color="surface" elevation="3" rounded="lg">
                                    <div class="d-flex flex-column text-center">
                                        <div style="display: flex; align-items: center;">
                                            <v-avatar class="mr-4" size="65">
                                                <v-img :src="$store.state.fileBaseUrl+employe.image" cover></v-img>
                                            </v-avatar>
                                            <div style="flex-grow: 1;">
                                                <div style="text-align: right;">
                                                    <h4 class="mr-4">{{ employe.title }}</h4>
                                                </div>
                                                <div style="text-align: left;">
                                                    <v-rating v-model="employe.rating" size="20" color="yellow-darken-3"
                                                    half-increments readonly></v-rating>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            v-if="!! employe.options && !! employe.options.services && employe.options.services.length > 0">
                                            {{ $t('booking.services_label') }}
                                            <v-chip v-for="(s, index) in employe.options.services" :key="index"
                                                size="small" :value="s.id" class="ma-1">
                                                {{ $store.state.serviceName[s.id] }}
                                            </v-chip>
                                        </div>
                                        <v-btn color="primary" rounded="lg" class="mt-4"
                                            @click="$store.commit('setEmploye', employe); $store.commit('setBookingSelectServiceDialogStatus', true);">
                                            {{ $t('booking.reserve_button') }}
                                        </v-btn>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-tabs-window-item>
                </v-tabs-window>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import BusinessCardList from '@/components/BusinessCardList.vue';
    import Faqs from '@/components/faqs.vue';
    import TopBar from '@/components/top_bar.vue';

    import { useToast } from 'vue-toastification'; // ایمپورت Toast
    const toast = useToast();

    export default {
        name: "BookingPage",
        components: {
            BusinessCardList,
            Faqs,
            TopBar,
        },
        data() {
            return {
                tab: "services",
                selectedCategory: "all",
            };
        },
        methods: {
            Booking_select_service(service) {
                this.$store.commit('setService', service);
                if(!!this.$store.state.info.info_related_field && this.$store.state.info.info_related_field.length > 0){
                    if (this.$store.state.authToken == '') {
                        toast.error('برای رزرو باید ابتدا وارد پنل خود شوید!');
                        setTimeout(() => {
                            this.$store.commit('setLoginDialogStatus', true);
                        }, 2000);
                        return;
                    }
                    this.$store.commit('setBookingSelectInfoDialogStatus', true);
                    return;
                }
                this.$store.commit('setBookingSelectEmployeDialogStatus', true);
            }
        },
    };
</script>

<style>
    .text-center {
        text-align: center;
    }
   
</style>